import React from 'react';
import PropTypes from 'prop-types';
import t from './tokens';

// Pre-checkout cross-sell (Shoob v2 Figma "Don't leave past memories behind"):
// the student's PRIOR seasons that still have photos, so a parent can add past-
// year prints to the same order. Reuses the multi-season gallery — "View & order"
// opens that season (onView); "No thanks" continues to the cart (onSkip).
const s = {
  page: { background: t.pageBg, minHeight: '100vh', padding: '2.5rem 1.25rem' },
  inner: { maxWidth: 820, margin: '0 auto', textAlign: 'center' },
  h1: {
    fontSize: 'clamp(1.5rem,3vw,2rem)', fontWeight: 700, color: t.ink, margin: '0 0 0.5rem',
  },
  sub: { color: t.muted, margin: '0 0 2rem', fontSize: '1rem' },
  grid: {
    display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))', gap: '1rem', textAlign: 'left',
  },
  card: {
    background: t.surface,
    border: `1px solid ${t.border}`,
    borderRadius: t.radiusLg,
    boxShadow: t.shadowSm,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  thumb: {
    width: '100%', aspectRatio: '4 / 5', objectFit: 'cover', display: 'block', background: t.mutedSurface,
  },
  thumbEmpty: {
    width: '100%', aspectRatio: '4 / 5', background: t.mutedSurface, display: 'block',
  },
  body: { padding: '0.85rem 0.95rem 1rem' },
  label: { fontWeight: 700, color: t.ink, fontSize: '1rem' },
  count: { color: t.muted, fontSize: '0.85rem', margin: '0.15rem 0 0.75rem' },
  view: {
    width: '100%',
    background: t.brand,
    color: '#fff',
    border: 'none',
    borderRadius: t.radius,
    padding: '0.6rem',
    fontWeight: 700,
    cursor: 'pointer',
    fontSize: '0.9rem',
  },
  skip: {
    marginTop: '1.75rem',
    background: 'none',
    border: 'none',
    color: t.muted,
    cursor: 'pointer',
    fontWeight: 600,
    textDecoration: 'underline',
    fontSize: '0.95rem',
  },
};

const PastPhotosUpsell = ({
  seasons, studentName, adding, onView, onSkip,
}) => {
  const heading = studentName ? `Don't miss ${studentName}'s past photos` : "Don't miss your past photos";
  return (
    <div style={s.page}>
      <div style={s.inner}>
        <h1 style={s.h1}>{heading}</h1>
        <p style={s.sub}>
          We also have photos from previous years. Add prints from those to this order before you check out.
        </p>

        <div style={s.grid}>
          {seasons.map((se) => (
            <div key={se.student_image_id} style={s.card}>
              {se.thumb_url
                ? <img src={se.thumb_url} alt={se.label} style={s.thumb} />
                : <div style={s.thumbEmpty} />}
              <div style={s.body}>
                <div style={s.label}>{se.label}</div>
                <div style={s.count}>
                  {`${se.pose_count} photo${se.pose_count === 1 ? '' : 's'}`}
                </div>
                <button type="button" style={s.view} disabled={adding} onClick={() => onView(se.student_image_id)}>
                  View &amp; order
                </button>
              </div>
            </div>
          ))}
        </div>

        <button type="button" style={s.skip} disabled={adding} onClick={onSkip}>
          No thanks, continue to cart
        </button>
      </div>
    </div>
  );
};

PastPhotosUpsell.propTypes = {
  seasons: PropTypes.arrayOf(PropTypes.object).isRequired,
  studentName: PropTypes.string,
  adding: PropTypes.bool,
  onView: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
};

PastPhotosUpsell.defaultProps = { studentName: null, adding: false };

export default PastPhotosUpsell;
